import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import PropTypes from "prop-types";
import { getSecureRandom } from "../../Helper/random";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});

export function CustomLinearProgress(props) {
  const classes = useStyles();
  const [progress, setProgress] = React.useState(0);
  const [buffer, setBuffer] = React.useState(10);
  const [loading, setLoading] = React.useState(false);

  const progressRef = React.useRef(() => {});
  React.useEffect(() => {
    if (!props.loading) {
      setProgress(99);
      setBuffer(100);
      var timeout = setTimeout(() => {
        setLoading(false);
      }, 900);
      return () => {
        clearTimeout(timeout);
      };
    } else {
      setProgress(0);
      setBuffer(0);
      setLoading(true);
    }
  }, [props.loading]);
  React.useEffect(() => {
    if (props.loading) {
      progressRef.current = () => {
        if (progress > 100) {
          setProgress(0);
          setBuffer(10);
        } else {
          const diff = getSecureRandom() * 10;
          const diff2 = getSecureRandom() * 10;
          if ((progress > 70 && progress < 74) || (progress > 81 && progress < 83)) {
            setProgress(progress - diff);
            setBuffer(progress - (diff + diff2));
          } else {
            setProgress(progress + diff);
            setBuffer(progress + diff + diff2);
          }
        }
      };
    }
  });

  React.useEffect(() => {
    const timer = setInterval(() => {
      progressRef.current();
    }, props.periodTime);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className={classes.root}>
      {loading && <LinearProgress variant="buffer" value={progress} valueBuffer={buffer} />}
    </div>
  );
}
export default CustomLinearProgress;
CustomLinearProgress.defaultProps = {
  periodTime: 600,
  loading: false,
};

CustomLinearProgress.propTypes = {
  ...LinearProgress.prototype,
  periodTime: PropTypes.number,
  loading: PropTypes.bool,
};
